import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import PeriodList from "@/modules/recognition/admin/components/PeriodList";
import { fetchPeriodsQueryOptions } from "@/modules/recognition/admin/services";

export const Route = createFileRoute(
  "/admin/_panel/_recognition/recognition/periods/",
)({
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "recognition.recognition-period.view");

    return {
      crumb: [
        {
          label: context.t("Apperication Periods", { ns: "recognition.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(fetchPeriodsQueryOptions()),
  component: Component,
});

function Component() {
  const { t } = useTranslation("recognition.admin");
  return (
    <Container
      title={t("Manage Appreciation Periods")}
      description={t("Mange, Create, Edit Appreciation Periods")}
    >
      <PeriodList />
    </Container>
  );
}
